import { Analysis } from '@core';
import { transformSkeletonToFramesFirst } from '@store';

import { AnalysisMessage } from '../message/schema';

export async function fetchAndShapeAnalysis(uuid: string, content: AnalysisMessage): Promise<Analysis> {
    const response = await fetch(content.analysis_url);
    const json = await response.json();
    const frames = transformSkeletonToFramesFirst(json.skeleton || {});

    return {
        uuid,
        data: {
            analysis: {
                timestamp: Date.now(),
                isQuickAnalysis: frames.length <= 10,
                frames,
                bones: json.bones,
                measurements: json.measurements,
                parameter_values: json.parameter_values,
                segmentation: json.segmentation,
                skeleton: json.skeleton,
                club_track: json.club_track,
                keypoint_id_to_name: json.keypoint_id_to_name,
            },
        },
    };
}
